import type { ReactNode } from 'react';
import { es } from '../i18n/es.js';
import { tripDates, tripPlace } from '../lib/trip.js';

interface HeaderProps {
  /** Page title; defaults to the trip place. */
  title?: string;
  /** Line under the title; defaults to the trip dates. */
  subtitle?: string;
  /** Right-hand actions on the wordmark row (sign-out, admin link…). */
  actions?: ReactNode;
}

/** Top bar shared by signed-in screens: wordmark + actions row, then title + subtitle. */
export function Header({ title = tripPlace, subtitle = tripDates, actions }: HeaderProps) {
  return (
    <header className="border-b border-neutral-200 pb-4 dark:border-neutral-800">
      <div className="flex min-h-11 items-center justify-between gap-3">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-accent">
          {es.appName}
        </p>
        {actions ? <div className="flex shrink-0 items-center gap-1 -mr-3">{actions}</div> : null}
      </div>
      <h1 className="mt-1 text-2xl font-semibold leading-tight tracking-tight">{title}</h1>
      <p className="mt-0.5 text-sm text-neutral-500 dark:text-neutral-400">{subtitle}</p>
    </header>
  );
}
